import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { customPreviewArtboardsLoaded, deselectAdStateContainers } from 'PreviewActions/customLayoutActions';
import { getMetadata, getAdId } from 'Selectors';
import AddNewLayout from 'PreviewComponents/AddNewLayout/AddNewLayout';
import LayoutRecord from 'PreviewRecords/LayoutRecord';
import LoadingSpinner from 'PreviewComponents/LoadingSpinner/LoadingSpinner';
import { MobileDeviceContainer } from 'PreviewComponents/MobileDeviceContainer/MobileDeviceContainer';
import LayoutAdStateContainer from 'PreviewComponents/LayoutAdStateContainer/LayoutAdStateContainer';
import ActiveAdStateContainer from 'PreviewComponents/ActiveAdStateContainer/ActiveAdStateContainer';
import LayoutBackgroundDropzone from 'PreviewComponents/LayoutBackgroundDropzone/LayoutBackgroundDropzone';
import {
  getActivePageLayout,
  getDeviceScale,
  getIsDevice,
  getLayoutBackgroundCSS,
  getLayoutContainerRect,
  setPageBackgroundColour,
  setQueryParams,
} from 'PreviewSelectors';

import {
  PRESENT,
  PREVIEW,
  LAYOUTS,
  APP,
  UI,
  TOPBAR_HEIGHT,
  ADSTATE_CONTAINERS_PATH,
} from 'SharedConstants/';

import {
  CUSTOM_PREVIEW_ARTBOARDS_LOADED,
  FIT_TO_SCREEN,
  SELECTED_CONTAINER,
  SELECTED_LAYOUT,
  MOBILE_DEVICE_TOOLBAR_HEIGHT,
} from 'PreviewConstants/';

const PreviewNotSupported = styled.div`
    position: absolute;
    width: auto;
    top: calc(50% - 40px);
    padding: 32px;
    margin-left: 20px;
    margin-right: 20px;
    text-align: center;
    background: rgba(200,200,200, 0.2);
    border-radius: 6px;
`;

const SiteWrapper = styled.div`
  position: relative;
  height: 100vh;
`;

const DesktopContainer = styled.div`
  position: relative;
  top: ${TOPBAR_HEIGHT}px;
  width: 100vw;
  height: calc(100vh - ${TOPBAR_HEIGHT}px);
  margin: auto;
  overflow: scroll;
`;

const ScrollableContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - ${props => props.heightOffset}px);
  overflow-x: hidden;
  overflow-y: scroll;
`;

const DefaultContainer = styled.div`
  position: relative;
  clip: rect(0px, auto, auto, 0px);
  clip-path: inset(0);
`;

const LayoutBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  ${props => props.backgroundMonochrome && { filter: 'grayscale(1)' }};
`;

const LayoutContainer = styled.div`
  position: absolute;
  background-size: 100% auto;
  background-repeat: no-repeat;
  ${props => props.backgroundImage && { backgroundColor: 'white' }};
`;


class PageContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.isDevice = getIsDevice() !== null;
  }
  componentDidMount() {
    const { isDevice } = this;
    const { activePageLayout } = this.props;
    // waiting for the ad to load. any better way?
    if (isDevice) {
      const adLoadInterval = setInterval(() => {
        if (!window['wve-api']) return;
        const spinner = document.getElementById('loading-spinner');
        if (spinner != null) { spinner.parentNode.removeChild(spinner); }
        clearInterval(adLoadInterval);
      });
    }
    if (activePageLayout) {
      this.adjustSiteAlignedContainers();
      setPageBackgroundColour(activePageLayout.background);
      window.addEventListener('resize', this.deselectAdStateContainersAndAdjustSiteContainers);
    }
    window.addEventListener('preview-artboard-loaded', this.arePreviewArtboardsLoaded);
    document.body.style.removeProperty('height');
  }
  componentDidUpdate() {
    const { activePageLayout } = this.props;
    if (activePageLayout) {
      this.adjustSiteAlignedContainers();
      setPageBackgroundColour(activePageLayout.background);
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.deselectAdStateContainersAndAdjustSiteContainers);
    window.removeEventListener('preview-artboard-loaded', this.arePreviewArtboardsLoaded);
  }

  arePreviewArtboardsLoaded = () => {
    const { customPreviewArtboardsLoaded } = this.props;
    const rootWindow = window;
    const rootDocument = rootWindow.document;
    const previewArtboards = rootDocument.querySelectorAll('[data-preview-artboard]');
    const previewArtboardsLoaded = rootDocument.querySelectorAll('[data-preview-artboard-loaded]');
    const artboardsLoaded = previewArtboards.length === previewArtboardsLoaded.length;
    if (artboardsLoaded) customPreviewArtboardsLoaded();
  };

  deselectAdStateContainersAndAdjustSiteContainers = () => {
    const { deselectAdStateContainers } = this.props;
    deselectAdStateContainers();
    this.adjustSiteAlignedContainers();
  }
  adjustSiteAlignedContainers = () => {
    const { isDevice } = this;
    const { activePageLayout } = this.props;

    if (!activePageLayout) return;

    const siteBackgroundDimensions = getLayoutContainerRect();
    const siteBackground = document.querySelector('.site-background');

    if (activePageLayout.device === 'desktop') {
      document.querySelectorAll('[data-fixed=true]').forEach((container) => {
        const containerStyle = container.style;
        containerStyle.transform = `translate(${siteBackground.offsetLeft}px, ${siteBackgroundDimensions.top}px)`;
      });
      document.querySelectorAll('[data-fixed=false]').forEach((container) => {
        const containerStyle = container.style;
        containerStyle.transform = 'none';
      });
    }

    if ((activePageLayout.device !== 'desktop') && !isDevice) {
      const previewDeviceContainer = document.querySelector('.preview-device-container');
      const windowHeight = window.innerHeight - TOPBAR_HEIGHT;
      const deviceHeight = previewDeviceContainer.offsetHeight + TOPBAR_HEIGHT;
      const deviceScale = windowHeight / deviceHeight;
      const adjustedScale = (deviceScale < 1) ? deviceScale : 1;
      previewDeviceContainer.style.transform = `scale(${adjustedScale})`;
    }
  };
  render() {
    const { isDevice } = this;
    const {
      addLayoutBacgkround,
      activePageLayout,
      campaignAccess,
      preview,
      deselectAdStateContainers,
      previewArtboardsLoaded,
      selectedContainer,
    } = this.props;

    setQueryParams(selectedContainer, activePageLayout);
    const isCustom = (selectedContainer === 'custom');
    if (!activePageLayout && campaignAccess && isCustom) return <AddNewLayout />;
    if (!activePageLayout) return <SiteWrapper />;

    const backgroundAlign = activePageLayout.backgroundAlign;
    const backgroundDimensions = activePageLayout.backgroundDimensions;
    const adStateContainers = activePageLayout.getAdStateContainers(preview);
    const device = activePageLayout.device || 'desktop';
    const isMobile = (device !== 'desktop');

    const layoutBackgroundCSS = getLayoutBackgroundCSS(device, isDevice, backgroundAlign, backgroundDimensions);
    const useMobileLayout = isMobile && (!isDevice || (isDevice && activePageLayout.inApp));

    const DeviceContainer = useMobileLayout ? MobileDeviceContainer : DesktopContainer;
    const selectedAdStateContainer = adStateContainers.find(adStateContainer => adStateContainer.selected) || null;
    const deviceScrollableTopOffset = activePageLayout.inApp ? activePageLayout.deviceHeader : 0;
    const deviceScrollableHeightOffset = activePageLayout.inApp ? activePageLayout.deviceHeader : MOBILE_DEVICE_TOOLBAR_HEIGHT;
    const scrollerContainerHeightOffset = (isMobile && !isDevice) ? deviceScrollableHeightOffset : 0;
    const deviceScale = isDevice ? getDeviceScale(device) : 1;

    const loadingPreview = !previewArtboardsLoaded && adStateContainers.size;

    if (isDevice && !isMobile) return <PreviewNotSupported>Please view this link on a desktop. It cannot be viewed on a mobile device.</PreviewNotSupported>;

    return (
      <SiteWrapper onMouseDown={deselectAdStateContainers}>
        <DeviceContainer
          device={device}
          isMobile={isMobile}
          inApp={activePageLayout.inApp}
          deviceHeader={activePageLayout.deviceHeader}
          background={activePageLayout.background}
          className="preview-device-container"
        >
          <ScrollableContainer
            device={device}
            isDevice={isDevice}
            heightOffset={scrollerContainerHeightOffset}
            className="preview-scrollable-container"
          >
            <DefaultContainer
              isDevice={isDevice}
              style={{
                height: layoutBackgroundCSS.height,
                marginTop: `-${deviceScrollableTopOffset}px`,
                overflow: 'hidden',
              }}
            >
              <LayoutContainer
                backgroundImage={activePageLayout.background !== '' && !activePageLayout.background.includes('missing.png')}
                className="site-background"
                style={{
                  ...layoutBackgroundCSS,
                }}
              >
                <LayoutBackground
                  backgroundMonochrome={activePageLayout.backgroundMonochrome}
                  style={{
                    backgroundImage: `url(${activePageLayout.background})`,
                    opacity: activePageLayout.backgroundOpacity,
                  }}
                />
                {adStateContainers.valueSeq().map(adStateContainer => (
                  <LayoutAdStateContainer
                    key={adStateContainer.key}
                    adStateContainer={adStateContainer}
                    deviceScale={deviceScale}
                    selectedAdStateContainer={selectedAdStateContainer}
                  />),
                )}
              </LayoutContainer>
            </DefaultContainer>
          </ScrollableContainer>
        </DeviceContainer>
        {(campaignAccess && (activePageLayout.background === '' || activePageLayout.background.includes('missing.png'))) &&
          <LayoutBackgroundDropzone />
        }
        {selectedAdStateContainer &&
          <ActiveAdStateContainer
            key={selectedAdStateContainer.key}
            adStateContainer={selectedAdStateContainer}
          />
        }
        {loadingPreview && <LoadingSpinner />}
      </SiteWrapper>
    );
  }
}

PageContainer.propTypes = {
  activePageLayout: PropTypes.instanceOf(LayoutRecord),
  campaignAccess: PropTypes.bool.isRequired,
  fitToScreen: PropTypes.bool.isRequired,
  selectedLayout: PropTypes.string,
  preview: PropTypes.object.isRequired,
  availableLayouts: PropTypes.object.isRequired,
  revealFormat: PropTypes.bool,
  previewArtboardsLoaded: PropTypes.bool,
  adId: PropTypes.number,
  selectedContainer: PropTypes.string,
};

PageContainer.defaultProps = {
  preview: {},
  availableLayouts: {},
  campaignAccess: false,
  revealFormat: false,
  selectedLayout: '',
  maintainAspectRatio: false,
  previewArtboardsLoaded: false,
  adId: 0,
  selectedContainer: 'page',
};

const mapStateToProps = state => ({
  allContainers: state.getIn([...ADSTATE_CONTAINERS_PATH]).map(adStateContainer => adStateContainer.key).toIndexedSeq().toArray(),
  activePageLayout: getActivePageLayout(state),
  campaignAccess: state.getIn([UI, 'campaignAccess']),
  fitToScreen: state.getIn([UI, FIT_TO_SCREEN]),
  previewArtboardsLoaded: state.getIn([UI, CUSTOM_PREVIEW_ARTBOARDS_LOADED]),
  preview: state.getIn([APP, PRESENT, PREVIEW]),
  selectedLayout: state.getIn([UI, SELECTED_LAYOUT]),
  availableLayouts: state.getIn([APP, PRESENT, PREVIEW, LAYOUTS]),
  revealFormat: getMetadata(state).get('revealFormat') || getMetadata(state).get('formatName') === 'Scroller',
  maintainAspectRatio: getMetadata(state).get('maintainAspectRatio'),
  adId: getAdId(state),
  selectedContainer: state.getIn([UI, SELECTED_CONTAINER]),
});

const mapDispatchToProps = dispatch => ({
  customPreviewArtboardsLoaded: () =>
    dispatch(customPreviewArtboardsLoaded()),
  deselectAdStateContainers: () =>
    dispatch(deselectAdStateContainers()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageContainer);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/PageContainer/PageContainer.jsx